import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { DataScienceEnums } from 'dashboard-services/api/dataScience';

import { builderPipelineCreatorActions } from 'actions/modules/datascience';

import ValueTypeResolverBody from 'components/modules/DataScience/PipelineCreator/Options/ValueTypeResolver/Body';
import ValueTypeResolverHeader from 'components/modules/DataScience/PipelineCreator/Options/ValueTypeResolver/Header';

const EMPTY_OBJ = {};
const EMPTY_ARRAY = [];

const Param = ({ param = EMPTY_OBJ, paramIndex, taskParams = EMPTY_ARRAY, getAllParams, onChange, taskName }) => {
  const dependsOnParam = useMemo(() => (taskParams || []).filter(p => p.type === DataScienceEnums.TASK_PARAM_TYPE.INPUT).find(p => p.name === param.dependsOn) || EMPTY_OBJ, [param.dependsOn, taskParams]),
        links = useSelector(state => state.datascienceState.creatorState.builderState.links || EMPTY_ARRAY),
        optionsWithTooltipPosition = useMemo(() => param.options?.map(p => ({
          value: p,
          label: p,
          tooltipPosition: "left",
        })), [param.options]),
        referenceDependsOnParam = useMemo(() => (taskParams || []).filter(p => p.type === DataScienceEnums.TASK_PARAM_TYPE.INPUT).find(p => p.name === dependsOnParam?.dependsOn) || EMPTY_OBJ, [dependsOnParam?.dependsOn, taskParams]),
        shouldShowTaskParam = useMemo(() => builderPipelineCreatorActions.shouldShowTaskParam(param, { params: taskParams }, links), [param, taskParams, links]),
        onChangeLocal = useCallback(value => onChange(value, "value", paramIndex), [onChange, paramIndex]),
        [targetElement, setTargetElement] = useState(),
        resolverRef = useRef()

  useEffect(() => {
    setTargetElement(document.getElementsByClassName("ng-python-editor__parameters")[0] || resolverRef.current?.parentElement)
  }, [])

  if(!shouldShowTaskParam) {
    return;
  }
  return (
    <div 
        className="data-science__pipeline-creator__body__options__resolver"
        ref={resolverRef}
    >
      <ValueTypeResolverHeader
          dependsOnParam={dependsOnParam}
          description={param?.description}
          disabled={false}
          expression={param?.expression}
          getAllParams={getAllParams}
          isInModal
          name={param?.name}
          onChange={onChangeLocal}
          optional={param?.optional}
          readableName={param?.readableName}
          taskName={taskName}
          value={param?.value}
          valueType={param?.valueType}
          withProvider={param?.withProvider}
          withUnlock={false}
      />
      <ValueTypeResolverBody
          className="data-science__pipeline-creator__body__options__resolver__bottom-row"
          dependsOnParam={dependsOnParam}
          disabled={false}
          fileExtension={param?.fileExtension}
          fileType={param?.fileType}
          menuPortalTarget={targetElement}
          name={param?.name}
          onChange={onChangeLocal}
          optional={param?.optional}
          options={optionsWithTooltipPosition}
          referenceDependsOnParam={referenceDependsOnParam}
          taskName={taskName}
          value={param?.value}
          valueType={param?.valueType}
          withProvider={param?.withProvider}
          withShowPassword
      />
    </div>
  )
}

Param.propTypes = {
  getAllParams: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  param: PropTypes.object,
  paramIndex: PropTypes.number.isRequired,
  taskName: PropTypes.string.isRequired,
  taskParams: PropTypes.array
}

export default Param;
